<section class="container-fluid p-4" [ngClass]="isMobile ? 'bg-white' : 'bg-gray'">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <!-- Page Header -->
      <div class="pb-4 d-md-flex align-items-center justify-content-between">
        <div class="mb-3 mb-md-0">
          <h1 class="mb-1 h2 fw-bold" [ngClass]="{'d-none' : isMobile}">My Tests</h1>
        </div>
        <div class="admin-search-container position-relative">
          <app-generic-search
            placeholder="Search Test"
            [selectedResult]="selectedResult"
            (searchChanged)="handleSearch($event, pageNumber, pageSize)"
          />

          <div class="position-absolute z-index-9 w-100" *ngIf="!isMobile">
            <ul *ngIf="searchResults.length > 0 && isSelectResultsOpened" class="form-control z-index-9 mt-2 custom-rounded bg-white overflow-auto shadow">
              <div *ngFor="let result of searchResults" class="cursor-pointer">
                <div (click)=" selectTest(result.name)" class="d-flex align-items-center gap-2">
                  <div class="custom-check pt-1 text-blue">&#10003;</div>
                  <div class="overline-text">{{ result.name }}</div>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <!-- Card -->
      <div *ngIf="!isMobile" class="card rounded-3">
        <div>
          <!-- Table -->
          <div class="tab-content" id="tabContent">
            <!--Tab pane -->
            <div class="tab-pane fade show active" id="courses" role="tabpanel" aria-labelledby="courses-tab">
              <div class="table-responsive border-0 overflow-y-hidden rounded-3">
                <table class="table mb-0 text-nowrap table-centered table-hover rounded-3">
                  <thead class="bg-white">
                  <tr>
                    <th class="fw-light text-gray" scope="col">
                      TEST
                    </th>
                    <th class="fw-light text-gray" scope="col">
                      CATEGORY
                    </th>
                    <th class="fw-light text-gray" scope="col">
                      STATUS
                    </th>
                    <th class="fw-light text-gray" scope="col">
                      DATE
                    </th>
                    <th class="fw-light text-gray" scope="col">DESCRIPTION</th>
                    <th class="fw-light text-gray" scope="col">TOTAL RESULT</th>
                    <th class="fw-light text-gray" scope="col"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let quiz of quizzes, let page = index" [routerLink]="['/quiz/add']"
                      [queryParams]="{id : quiz.id}" class="cursor-pointer fs-6">
                    <td>
                      <a class="text-inherit" [routerLink]="['/quiz/add']"
                         [queryParams]="{id : quiz.id}">
                        <div class="d-flex align-items-center">
                          <div>
                            <img *ngIf="quiz.logoUpload; else defaultLogo"
                                 [src]="apiUrl+'/image?picName='+quiz.logoUpload"
                                 class="img-preview">
                            <ng-template #defaultLogo>
                              <img src="/assets/default-ui-image-placeholder-wireframes-600nw-1037719192.webp"
                                   alt=""
                                   class="img-preview">
                            </ng-template>
                          </div>
                          <div class="ms-3">
                            <h4 class="mb-1 fs-6 text-primary-hover text-normal">
                              {{ quiz.name }}
                            </h4>
                          </div>
                        </div>
                      </a>
                    </td>
                    <td *ngIf="quiz.category">
                      <div class="d-flex align-items-center">
                        <h5 class="mb-0 unset-font-weight fs-6">{{ quiz.category }}</h5>
                      </div>
                    </td>
                    <td>
                      <div class="mdc-drawer__status-tag status-color align-items-center fs-6 text-center text-capitalize"
                           [ngClass]="{'t_violet': quiz.status === QuizStatus.SETUP_IN_PROGRESS,
                                           't_green': quiz.status === QuizStatus.ACTIVE,
                                           't_gray': quiz.status === QuizStatus.ENDED}">
                        <img *ngIf="quiz.status === QuizStatus.ACTIVE" class="mr-1 align-bottom"
                             src="/assets/images/svg/check_circle.svg" alt="active">
                        {{ getStatus(quiz.status.toString()) }}
                      </div>
                    </td>
                    <td class="fs-6">
                      <span class="dark-gray">{{ quiz.createdDate | date }}</span>
                    </td>
                    <td class="with fs-6" style="word-wrap: break-word">
                      <span class="dark-gray" [innerHTML]="getSanitizedHTML(quiz.description)"></span>
                    </td>
                    <td class="text-end fs-6">
                      <span class="dark-gray">{{ quiz.totalResult === 0 ? '' : quiz.totalResult }}</span>
                    </td>
                    <td>
                          <span class="dropdown dark-gray dropstart" (click)="$event.stopPropagation()">
                            <button class="btn-icon btn btn-ghost btn-sm rounded-circle"
                                    [matMenuTriggerFor]="beforeMenu" aria-label="Open menu">
                            <i class="fe fe-more-vertical vertical-font-size"></i>
                            </button>
                            <span class="dark-gray dropdown-menu">
                              <mat-menu #beforeMenu="matMenu" xPosition="before">
                                <button class="dropdown-item p-2"
                                        (click)="openDuplicateDialog(quiz?.name, quiz?.id)">
                                  <img src="./assets/images/svg/copy.svg" alt="copy">
                                  <span class="p-lg-1">Duplicate</span>
                                </button>
                                <button class="dropdown-item p-2" (click)="openDeleteDialog(quiz?.id)"
                                        *ngIf="!canDelete(quiz.status)">
                                  <img src="./assets/images/svg/bin.svg" alt="delete">
                                  <span class="p-lg-1">Delete</span>
                                </button>
                                <button class="dropdown-item p-2" [routerLink]="['/quiz/add']"
                                        [queryParams]="{id : quiz.id}" *ngIf="!canEdit(quiz.status)">
                                  <img src="./assets/images/svg/edit.svg" alt="edit">
                                  <span class="p-lg-1">Edit</span>
                                </button>
                              </mat-menu>
                            </span>
                          </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--  table end-->
        </div>
        <!-- Card Footer -->
        <ng-container *ngTemplateOutlet="paginatorTpl"/>

      </div>
      <div class="row" *ngIf="isMobile && !showSearchMobile">
        <div class="col-md-8 mx-auto fs-4">
          <!-- Test Items -->
          <div class="mt-3 mr-1" *ngFor="let quiz of quizzes, let page = index"
               [routerLink]="['/quiz/add']"
               [queryParams]="{id : quiz.id}">

            <div class="card mb-2 shadow-none">
              <div class="d-flex justify-content-between align-content-center">
                <div class="mb-4">
                  <img *ngIf="quiz.logoUpload; else defaultLogo"
                       [src]="apiUrl+'/image?picName='+quiz.logoUpload"
                       class="img-preview">
                  <ng-template #defaultLogo>
                    <img src="/assets/default-ui-image-placeholder-wireframes-600nw-1037719192.webp"
                         alt=""
                         class="img-preview">
                  </ng-template>
                  <span class="dark-gray p-3 text-wrap">{{ quiz.name }}</span>

                </div>
                <div class="d-flex justify-content-between align-items-center mb-6">
                  <div class="mdc-drawer__status-tag status-color align-items-center fs-6"
                       [ngClass]="{'t_violet': quiz.status === QuizStatus.SETUP_IN_PROGRESS,
                                           't_green': quiz.status === QuizStatus.ACTIVE,
                                           't_gray': quiz.status === QuizStatus.ENDED}">
                    <img *ngIf="quiz.status === QuizStatus.ACTIVE" class="w-20"
                         src="/assets/images/svg/check_circle.svg" alt="active">
                    <img *ngIf="quiz.status === QuizStatus.SETUP_IN_PROGRESS"
                         src="./assets/images/svg/setup.svg" alt="setup">

                    {{ quiz.status === QuizStatus.SETUP_IN_PROGRESS ? splitStatusForMobile(quiz.status) : quiz.status }}
                  </div>
                  <span class="dark-gray dropdown dropstart" (click)="$event.stopPropagation()">
                            <button class="btn-icon btn btn-ghost btn-sm rounded-circle"
                                    [matMenuTriggerFor]="beforeMenu" aria-label="Open menu">
                            <i class="fe fe-more-vertical vertical-font-size"></i>
                            </button>
                            <span class="dark-gray dropdown-menu">
                              <mat-menu #beforeMenu="matMenu" xPosition="before">
                                <button class="dropdown-item p-2"
                                        (click)="openDuplicateDialog(quiz?.name, quiz?.id)">
                                  <img src="./assets/images/svg/copy.svg" alt="duplicate">
                                  <span class="dark-gray p-lg-1">Duplicate</span>
                                </button>
                                <button class="dropdown-item p-2" (click)="openDeleteDialog(quiz?.id)"
                                        *ngIf="!canDelete(quiz.status)">
                                  <img src="./assets/images/svg/bin.svg" alt="delete">
                                  <span class="dark-gray p-lg-1">Delete</span>
                                </button>
                                <button class="dropdown-item p-2" [routerLink]="['/quiz/add']"
                                        [queryParams]="{id : quiz.id}" *ngIf="!canEdit(quiz.status)">
                                <img src="./assets/images/svg/edit.svg" alt="edit">
                                  <span class="dark-gray p-lg-1">Edit</span>
                                </button>
                              </mat-menu>
                            </span>
                          </span>
                </div>
              </div>
              <p class="text-secondary">Category: <span
                class="dark-gray text-dark-blue">{{ quiz.category }}</span>
              </p>

              <p class="text-secondary">Date: <span
                class="dark-gray text-dark-blue">{{ quiz.createdDate }}</span>
              </p>

              <p class="text-secondary">Total Results: <span
                class="dark-gray text-dark-blue">{{ quiz.totalResult }}</span>
              </p>

              <p class="pt-2 text-gray" [innerHTML]="getSanitizedHTML(quiz.description)">
              </p>

            </div>
          </div>

        </div>
      </div>
        <div class="row" *ngIf="isMobile && showSearchMobile">
          <div class="col-12 col-md-10 col-lg-8 mx-auto">
            <ul *ngIf="searchResults.length > 0 && isSelectResultsOpened" class="list-unstyled p-2">
              <div *ngFor="let result of searchResults" class="cursor-pointer">
                <div
                  (click)="selectTest(result.name)"
                  class="d-flex align-items-center gap-2 fs-3 py-2"
                >
                  <div class="custom-check pt-1 text-primary">&#10003;</div>
                  <div class="overline-text flex-grow-1 text-truncate">{{ result.name }}</div>
                </div>
              </div>
            </ul>
          </div>
      </div>
        <ng-container *ngTemplateOutlet="paginatorTpl" class="w-auto"/>
      </div>

      <ng-template #paginatorTpl>
        <app-paginator
          [totalItems]="quizzesTotalCount"
          [pageSize]="pageSize"
          [currentPage]="pageNumber"
          [maxVisiblePages]="maxVisiblePages"
          (pageChange)="onPageChange($event)"
        />
      </ng-template>

    </div>
</section>
